/** @file Renames a bone (ASCII name, unique among bones); generated socket bones follow their socket. */
import { defineCommand } from '../defineCommand';
import { defineRename } from '../_shared/defineRename';
import { assertNotSocketBone } from '../_shared/assertNotSocketBone';

const rename = defineRename({
  domain: 'bone',
  kind: 'bone',
  description: 'Rename a bone (ASCII name, unique among bones; use -L/-R suffixes for sides); generated socket bones cannot be renamed (edit the socket instead).',
});

export const command = defineCommand({
  ...rename,
  apply(draft, input, ctx) {
    assertNotSocketBone(draft, ctx.resolve('bone', input.target));
    rename.apply(draft, input, ctx);
  },
});
